module.exports = __webpack_public_path__ + "649122b8ed73f30b12717dbee48fdb02.jpg";